import { render, staticRenderFns } from "./Warehousing.vue?vue&type=template&id=6dd57ac3"
import script from "./Warehousing.vue?vue&type=script&lang=js"
export * from "./Warehousing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports